<div class="migration-processing-data-entities">
  <div class="card">
    <div class="card-header">
      <h5>Migration Data Entity Mapping</h5>
    </div>
    <div class="card-body">
      <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
      <div *ngIf="loading" class="text-center">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p>Loading...</p>
      </div>

      <!-- Tabs Navigation -->
      <ul
        class="nav nav-tabs mb-3"
        *ngIf="!loading && entities.length > 0"
        role="tablist"
      >
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            [class.active]="activeTab === 'entities'"
            (click)="activeTab = 'entities'"
            type="button"
          >
            <i class="fa fa-table me-2"></i>
            Parsed Fields
            <span class="badge bg-primary text-white ms-2">{{
              entities.length
            }}</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            [class.active]="activeTab === 'routing'"
            (click)="onRoutingTabClick()"
            type="button"
          >
            <i class="fa fa-route me-2"></i>
            Routing
            <span
              *ngIf="routingInfo && routingInfo.routes"
              class="badge bg-primary text-white ms-2"
              >{{ routingInfo.routes.length }}</span
            >
          </button>
        </li>
      </ul>

      <!-- Tab Content -->
      <div class="tab-content">
        <!-- Data Entities Tab -->
        <div *ngIf="activeTab === 'entities'">
          <div
            *ngIf="!loading && entities.length === 0"
            class="alert alert-info"
          >
            No data entities found. Upload a metadata JSON file to automatically
            create entities.
          </div>

          <!-- Section Selection -->
          <div *ngIf="!loading && entities.length > 0" class="mb-3">
            <div class="row align-items-center">
              <div class="col-auto">
                <label class="mb-0 mr-2"
                  ><strong>Select by Section:</strong></label
                >
              </div>
              <div class="col-auto">
                <select
                  class="form-control form-control-sm"
                  [(ngModel)]="selectedSection"
                  (change)="selectBySection()"
                  style="width: 250px;"
                >
                  <option value="">-- Choose a section --</option>
                  <option
                    *ngFor="let section of uniqueSections"
                    [value]="section"
                    >{{ section }}</option
                  >
                </select>
              </div>
              <div class="col-auto">
                <button
                  class="btn btn-sm btn-info"
                  (click)="selectBySection()"
                  [disabled]="!selectedSection"
                >
                  <i class="fa fa-check-square"></i> Select All in Section
                </button>
              </div>
            </div>
          </div>

          <!-- Bulk Update Section -->
          <div
            *ngIf="!loading && entities.length > 0 && selectedEntities.size > 0"
            class="alert alert-info"
          >
            <div class="row align-items-center mb-2">
              <div class="col-auto">
                <strong>{{ selectedEntities.size }} item(s) selected</strong>
              </div>
              <div class="col-auto">
                <div class="btn-group">
                  <button
                    class="btn btn-sm btn-secondary"
                    (click)="moveSelectedUp()"
                    title="Move selected items up"
                  >
                    <i class="fa fa-arrow-up"></i> Move Up
                  </button>
                  <button
                    class="btn btn-sm btn-secondary"
                    (click)="moveSelectedDown()"
                    title="Move selected items down"
                  >
                    <i class="fa fa-arrow-down"></i> Move Down
                  </button>
                </div>
              </div>
              <div class="col-auto">
                <label class="mb-0 mr-2">Move After Section:</label>
              </div>
              <div class="col-auto">
                <select
                  class="form-control form-control-sm"
                  [(ngModel)]="moveAfterSection"
                  style="width: 200px;"
                >
                  <option value="">-- Choose section --</option>
                  <option
                    *ngFor="let section of uniqueSections"
                    [value]="section"
                    >{{ section }}</option
                  >
                </select>
              </div>
              <div class="col-auto">
                <button
                  class="btn btn-sm btn-warning"
                  (click)="moveSelectedAfterSection()"
                  [disabled]="!moveAfterSection"
                >
                  <i class="fa fa-arrow-right"></i> Move After
                </button>
              </div>
              <div class="col-auto">
                <label class="mb-0 mr-2">Move Before Section:</label>
              </div>
              <div class="col-auto">
                <select
                  class="form-control form-control-sm"
                  [(ngModel)]="moveBeforeSection"
                  style="width: 200px;"
                >
                  <option value="">-- Choose section --</option>
                  <option
                    *ngFor="let section of uniqueSections"
                    [value]="section"
                    >{{ section }}</option
                  >
                </select>
              </div>
              <div class="col-auto">
                <button
                  class="btn btn-sm btn-warning"
                  (click)="moveSelectedBeforeSection()"
                  [disabled]="!moveBeforeSection"
                >
                  <i class="fa fa-arrow-left"></i> Move Before
                </button>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-auto">
                <label class="mb-0 mr-2">Bulk Update Target Activity:</label>
              </div>
              <div class="col-auto">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [(ngModel)]="bulkTargetActivity"
                  placeholder="Enter target activity"
                  style="width: 200px;"
                />
              </div>
              <div class="col-auto">
                <button
                  class="btn btn-sm btn-primary"
                  (click)="applyBulkUpdate()"
                  [disabled]="!bulkTargetActivity"
                >
                  <i class="fa fa-check"></i> Apply to Selected
                </button>
                <button
                  class="btn btn-sm btn-secondary ml-2"
                  (click)="clearSelection()"
                >
                  <i class="fa fa-times"></i> Clear Selection
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="!loading && entities.length > 0" class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th style="width: 40px;">
                    <input
                      type="checkbox"
                      [checked]="isAllSelected()"
                      (change)="toggleSelectAll($event)"
                    />
                  </th>
                  <th
                    style="width: 40px;"
                    title="Expand/Collapse Child Fields"
                  ></th>
                  <th style="width: 50px;">Order</th>
                  <th>Section</th>
                  <th>Input Type</th>
                  <th style="width: 200px;">Label</th>
                  <th style="width: 200px;">Template Code</th>
                  <th style="width: 200px;">Target Activity</th>
                  <th style="width: 80px;" title="Conditional Configuration">
                    Conditional
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container
                  *ngFor="let entity of getVisibleEntities(); let i = index"
                >
                  <tr
                    [class.table-secondary]="!entity.isActive"
                    [class.cursor-pointer]="hasConditionalConfig(entity)"
                    [ngClass]="getChildFieldClass(entity)"
                  >
                    <td>
                      <input
                        type="checkbox"
                        [checked]="selectedEntities.has(entity.id)"
                        (change)="toggleSelection(entity)"
                      />
                    </td>
                    <td class="text-center">
                      <button
                        *ngIf="entity.hasChildFields"
                        type="button"
                        class="btn btn-sm btn-link p-0"
                        (click)="toggleChildrenExpanded(entity)"
                        title="Click to {{
                          entity.childrenExpanded ? 'collapse' : 'expand'
                        }} child fields"
                      >
                        <span>{{ entity.childrenExpanded ? '▼' : '▶' }}</span>
                        <!-- <i class="fa" [ngClass]="entity.childrenExpanded ? 'fa-caret-down' : 'fa-caret-right'"></i> -->
                      </button>
                    </td>
                    <td>
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm"
                          (click)="moveUp(entity, i)"
                          [disabled]="i === 0"
                          title="Move up"
                        >
                          <fa-icon [icon]="faCaretUp"></fa-icon>
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm"
                          (click)="moveDown(entity, i)"
                          [disabled]="i === entities.length - 1"
                          title="Move down"
                        >
                          <fa-icon [icon]="faCaretDown"></fa-icon>
                        </button>
                      </div>
                    </td>
                    <td [ngStyle]="getIndentStyle(entity)">
                      <span
                        *ngIf="isChildField(entity)"
                        class="child-field-indicator me-2"
                        title="Child field"
                      >
                        <i
                          class="fa fa-level-down-alt fa-rotate-90 text-muted"
                        ></i>
                      </span>
                      {{ entity.section }}
                    </td>
                    <td>
                      <span
                        *ngIf="isChildField(entity)"
                        class="badge bg-secondary text-white me-2"
                        style="font-size: 0.7em;"
                        >Child</span
                      >
                      {{ entity.inputType }}
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="entity.label"
                        (blur)="saveEntityField(entity)"
                        (keyup.enter)="saveEntityField(entity)"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="entity.templateCode"
                        (blur)="saveEntityField(entity)"
                        (keyup.enter)="saveEntityField(entity)"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="entity.targetActivity"
                        (blur)="saveEntityField(entity)"
                        (keyup.enter)="saveEntityField(entity)"
                      />
                    </td>
                    <td class="text-center">
                      <div
                        *ngIf="hasConditionalConfig(entity)"
                        class="d-flex align-items-center justify-content-center"
                      >
                        <button
                          type="button"
                          class="btn btn-sm btn-link p-0 me-2"
                          (click)="toggleExpand(entity)"
                          title="Click to {{
                            entity.expanded ? 'collapse' : 'expand'
                          }} conditions"
                        >
                          <span
                            >{{ entity.expanded ? 'Collapse' : 'Expand' }}
                          </span>
                          <!-- <i class="fa" [ngClass]="entity.expanded ? 'fa-caret-down' : 'fa-caret-right'"></i> -->
                        </button>
                        <span
                          title="Conditional visibility configured"
                          *ngIf="hasConditionallyVisible(entity)"
                        >
                          <i class="fa fa-eye text-info"></i>
                        </span>
                        <span
                          title="Conditionally required configured"
                          *ngIf="hasConditionallyRequired(entity)"
                          class="ms-1"
                        >
                          <i class="fa fa-asterisk text-warning"></i>
                        </span>
                      </div>
                      <span
                        *ngIf="!hasConditionalConfig(entity)"
                        class="text-muted"
                        >—</span
                      >
                    </td>
                  </tr>
                  <!-- Expanded Conditional Configuration Row -->
                  <tr *ngIf="entity.expanded" class="table-active">
                    <td colspan="9" class="p-3">
                      <div class="conditional-config-details">
                        <h6 class="mb-3">
                          <i class="fa fa-sliders-h me-2"></i>
                          Conditional Configuration for:
                          <strong>{{
                            entity.label || entity.inputName
                          }}</strong>
                        </h6>

                        <!-- Conditionally Visible -->
                        <div
                          *ngIf="hasConditionallyVisible(entity)"
                          class="mb-3"
                        >
                          <h6 class="text-info">
                            <i class="fa fa-eye me-2"></i>
                            Conditionally Visible
                            <span
                              *ngIf="getConditionallyVisibleOperator(entity)"
                              class="badge bg-secondary text-white ms-2"
                            >
                              {{ getConditionallyVisibleOperator(entity) }}
                            </span>
                          </h6>
                          <div class="table-responsive">
                            <table class="table table-sm table-bordered mb-0">
                              <thead class="table-light">
                                <tr>
                                  <th>Field</th>
                                  <th>Operator</th>
                                  <th>Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  *ngFor="
                                    let condition of parseConditions(
                                      getConditionallyVisibleJson(entity)
                                    )
                                  "
                                >
                                  <td>
                                    <code>{{ condition.Field }}</code>
                                  </td>
                                  <td>
                                    <span class="badge bg-info text-white">{{
                                      condition.Operator || 'IS'
                                    }}</span>
                                  </td>
                                  <td>{{ condition.Value }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <!-- Conditionally Required -->
                        <div *ngIf="hasConditionallyRequired(entity)">
                          <h6 class="text-warning">
                            <i class="fa fa-asterisk me-2"></i>
                            Conditionally Required
                            <span
                              *ngIf="getConditionallyRequiredOperator(entity)"
                              class="badge bg-secondary text-white ms-2"
                            >
                              {{ getConditionallyRequiredOperator(entity) }}
                            </span>
                          </h6>
                          <div class="table-responsive">
                            <table class="table table-sm table-bordered mb-0">
                              <thead class="table-light">
                                <tr>
                                  <th>Field</th>
                                  <th>Operator</th>
                                  <th>Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  *ngFor="
                                    let condition of parseConditions(
                                      getConditionallyRequiredJson(entity)
                                    )
                                  "
                                >
                                  <td>
                                    <code>{{ condition.Field }}</code>
                                  </td>
                                  <td>
                                    <span class="badge bg-warning text-white">{{
                                      condition.Operator || 'IS'
                                    }}</span>
                                  </td>
                                  <td>{{ condition.Value }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <!-- End Data Entities Tab -->

        <!-- Routing Tab -->
        <div *ngIf="activeTab === 'routing'">
          <div *ngIf="loadingRouting" class="text-center py-4">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
            <p class="mt-2">Loading routing information...</p>
          </div>

          <div *ngIf="!loadingRouting && routingInfo">
            <!-- No Routes -->
            <div
              *ngIf="!routingInfo.routes || routingInfo.routes.length === 0"
              class="alert alert-info"
            >
              <i class="fa fa-info-circle me-2"></i>
              No routing configuration found in the metadata file.
            </div>

            <!-- Routes Display -->
            <div *ngIf="routingInfo.routes && routingInfo.routes.length > 0">
              <div class="alert alert-success mb-3">
                <i class="fa fa-check-circle me-2"></i>
                <strong
                  >{{ routingInfo.routes.length }} route(s) defined in
                  metadata</strong
                >
              </div>

              <!-- Routes Table -->
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 150px;">Route Name</th>
                      <th style="width: 150px;">From Activity</th>
                      <th style="width: 150px;">To Activity</th>
                      <th style="width: 80px;">Logic</th>
                      <th>Conditions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let route of routingInfo.routes; let i = index">
                      <td>
                        <strong>{{ route.name || 'Route ' + (i + 1) }}</strong>
                      </td>
                      <td>
                        <span class="badge bg-info text-white">{{
                          route.fromActivity
                        }}</span>
                      </td>
                      <td>
                        <span class="badge bg-success text-white">{{
                          route.toActivity
                        }}</span>
                      </td>
                      <td>
                        <span
                          class="badge text-white"
                          [ngClass]="
                            route.logicalOperator === 'OR'
                              ? 'bg-warning'
                              : 'bg-secondary'
                          "
                        >
                          {{ route.logicalOperator || 'AND' }}
                        </span>
                      </td>
                      <td>
                        <div
                          *ngIf="
                            !route.conditions || route.conditions.length === 0
                          "
                          class="text-muted"
                        >
                          <em>No conditions</em>
                        </div>
                        <div
                          *ngIf="
                            route.conditions && route.conditions.length > 0
                          "
                        >
                          <div
                            *ngFor="
                              let condition of route.conditions;
                              let last = last
                            "
                            class="mb-1"
                          >
                            <code>{{ condition.field }}</code>
                            <span class="mx-1">{{ condition.operator }}</span>
                            <code>{{ condition.value }}</code>
                            <span *ngIf="!last" class="text-muted ms-2">
                              <em>{{ route.logicalOperator || 'AND' }}</em>
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Routing Legend -->
              <div class="card mt-3">
                <div class="card-body">
                  <h6 class="card-title">
                    <i class="fa fa-info-circle me-2"></i>
                    Routing Information
                  </h6>
                  <p class="mb-2"><strong>Logical Operators:</strong></p>
                  <ul class="mb-2">
                    <li>
                      <span class="badge bg-secondary text-white">AND</span> -
                      All conditions must be true
                    </li>
                    <li>
                      <span class="badge bg-warning text-white">OR</span> - Any
                      condition can be true
                    </li>
                  </ul>
                  <p class="mb-2">
                    <strong>Common Condition Operators:</strong>
                  </p>
                  <ul class="mb-0">
                    <li><code>IS</code> or <code>==</code> - Equals</li>
                    <li><code>IS_NOT</code> or <code>!=</code> - Not equals</li>
                    <li>
                      <code>GREATER_THAN</code> or <code>&gt;</code> - Greater
                      than
                    </li>
                    <li>
                      <code>LESS_THAN</code> or <code>&lt;</code> - Less than
                    </li>
                    <li>
                      <code>EXISTS</code> or <code>!!</code> - Field has a value
                    </li>
                    <li>
                      <code>NOT_EXISTS</code> or <code>!</code> - Field is empty
                    </li>
                    <li>
                      <code>CONTAINS</code> or <code>~</code> - Contains text
                    </li>
                    <li>
                      <code>DOES_NOT_CONTAIN</code> or <code>!~</code> - Does
                      not contain text
                    </li>
                    <li>
                      <code>RANGE</code> or <code>~~</code> - Within range
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Routing Tab -->
      </div>
    </div>
  </div>
</div>
